module.exports = __webpack_public_path__ + "img/biodc-small.279271e6.png";